module.exports = __webpack_public_path__ + "img/office-access-decor.8ecebe6.jpg";